import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppState } from '@/store';
import {
  getConversationById,
  resetConversationDetails,
  selectConversationDetails,
  selectConversationDetailsIsLoading,
} from '../feature';

export const useGetConversationById = (id?: string) => {
  const dispatch = useAppDispatch();
  const conversation = useAppState(selectConversationDetails);
  const isLoading = useAppState(selectConversationDetailsIsLoading);

  const refetch = useCallback(() => {
    if (!id) return;
    dispatch(getConversationById({ id }));
  }, [dispatch, id]);

  useEffect(() => {
    refetch();

    return () => {
      dispatch(resetConversationDetails());
    };
  }, [dispatch, refetch]);

  return { conversation, isLoading, refetch };
};
